import { schema } from 'normalizr';

export const elbow = new schema.Entity('elbows');

export const elbowList = new schema.Array(elbow);
